import { AssetTitle } from "domains/single-asset/shared";
import { FC, useMemo } from "react";
import { Grid } from "@chakra-ui/layout";
import { useRouter } from "next/router";
import { useLoggedinUser, usePack } from "lib/hooks";
import { Asset } from "lib/types";
import { isPreviewingPack, lookupFileIconName, md } from "lib/utils";
import { getIconComponent } from "lib/icons";
import { openFile } from "./utils";
import { isEditable } from "../../utils";
import { usePackContext } from "domains/pack";

export const DefaultFileAsset: FC<{ asset: Asset<any>}> = ({ asset }) => {
  const { data: user } = useLoggedinUser();
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);
  const { pathname } = useRouter();

  const canEdit = isEditable(asset, user, pack) && !isPreviewingPack(pathname);

  const assetMeta = useMemo(() => {
    let filename = '';

    if (asset.data.url) {
      // for backwards compatability
      const parts = asset.data.url.split('/');
      filename = parts[parts.length-1]
    }
    else if (asset.data.filename) {
      filename = asset.data.filename;
    }

    const nameParts = filename.split('.');
    const ext = nameParts[nameParts.length - 1] || '';

    const Icon = getIconComponent(lookupFileIconName(asset.data.content_type, ext));
    const displayName = asset.data.name ? md.render(asset.data.name) : filename;

    return { displayName, Icon }
  }, [ asset.data.url, asset.data.name, asset.data.content_type ]);

  return (
    <Grid
      templateColumns={["20px auto", "30px auto"]}
      gap="12px"
      alignItems="center"
      onClick={!canEdit ? (e) => openFile(e, pack, asset) : null}
    >
      {assetMeta.Icon && (
        <assetMeta.Icon boxSize={["20px", "30px"]} color="brand.500" />
      )}
      <AssetTitle title={assetMeta.displayName}/>
    </Grid>
  )
};
